import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { Rating } from '@/components/molecule/Rating';
interface MarketReviewSummaryProps {
  rating: number;
  reviewCount: number;
  className?: string;
}
export const MarketReviewSummary = t0 => {
  const $ = _c(17);
  const {
    rating,
    reviewCount,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center justify-center gap-12 border border-Gray-200 bg-Gray-25 p-20", "mobile-tablet:flex-col mobile-tablet:items-start mobile-tablet:gap-6", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className={cn("font-500 text-Gray-600 typo-body4")}>상품 만족도</p>;
    t3 = <div className="h-16 border-l border-Gray-300 mobile-tablet:hidden" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] !== rating) {
    t4 = <Rating value={rating} size={20} />;
    t5 = <p className="font-700 text-Gray-900 typo-h5">{rating}</p>;
    $[4] = rating;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="font-500 text-Gray-500 typo-body3">/5.0</p>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== reviewCount) {
    t7 = <p className="font-400 text-Gray-600 typo-body4">({reviewCount}개)</p>;
    $[8] = reviewCount;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t7) {
    t8 = <div className="flex items-center gap-4">{t4}{t5}{t6}{t7}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t1 || $[15] !== t8) {
    t9 = <div className={t1}>{t2}{t3}{t8}</div>;
    $[14] = t1;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};